'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ShelfItem = require('./ShelfItem');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ShelfItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/ShelfItem/index.js
// module id = 1286
// module chunks = 1